var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96992 7.33789H38.0269C39.5891 7.33789 40.8555 8.65104 40.8555 10.2709V33.735C40.8555 35.3548 39.5891 36.668 38.0269 36.668H5.96992C4.40775 36.668 3.14137 35.3548 3.14137 33.735V10.2709C3.14137 8.65104 4.40775 7.33789 5.96992 7.33789Z",
    fill: "#9EBAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2012 17.918C23.5728 17.9315 24.893 18.4614 25.916 19.4089L40.8555 34.0006C40.8201 34.7425 40.5024 35.4395 39.9722 35.9389C39.442 36.4383 38.7424 36.6993 38.0269 36.6648H5.96992C5.25472 36.698 4.55589 36.4366 4.02595 35.9374C3.49601 35.4383 3.178 34.742 3.14137 34.0006L18.4486 19.404C18.4486 19.404 19.6602 17.918 22.2012 17.918Z",
    fill: "#89A9FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8004 26.0838C20.4276 26.0721 19.1063 25.5401 18.0856 24.588L3.14137 10.0012C3.178 9.25979 3.49601 8.56354 4.02595 8.0644C4.55589 7.56526 5.25471 7.30378 5.96992 7.33703H38.0269C38.7424 7.30247 39.442 7.56351 39.9722 8.06291C40.5024 8.56231 40.8201 9.25934 40.8555 10.0012L25.553 24.5929C25.553 24.5929 24.3414 26.0838 21.8004 26.0838Z",
    fill: "#BFD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.9d6bd959cc73cf22e7ed6cb514cad93c.svg";
export { ForwardRef as ReactComponent };